import { render, staticRenderFns } from "./KampusMerdeka.vue?vue&type=template&id=ed970880&scoped=true"
import script from "./KampusMerdeka.vue?vue&type=script&lang=js"
export * from "./KampusMerdeka.vue?vue&type=script&lang=js"
import style0 from "./kampusMerdeka.css?vue&type=style&index=0&id=ed970880&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed970880",
  null
  
)

export default component.exports